import React, { memo, forwardRef } from "react";
const SvgNotaelementof = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M9.768 24.507a1 1 0 101.732 1l.647-1.12a7.964 7.964 0 003.853.986h7a1 1 0 100-2h-7a5.974 5.974 0 01-2.852-.72l2.47-4.28H22a1 1 0 100-2h-5.227l2.887-5H23a1 1 0 100-2h-2.185l.685-1.186a1 1 0 10-1.732-1l-1.262 2.186H16a8 8 0 00-5.479 13.83l-.753 1.304zm1.79-3.1l1.751-3.034h-3.226a5.98 5.98 0 001.475 3.034zm2.906-5.034l2.887-5H16a6.002 6.002 0 00-5.917 5h4.381z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgNotaelementof.displayName = "SvgNotaelementof";
const MemoForwardRef = memo(SvgNotaelementof);
export default MemoForwardRef;
